import { Component, ViewChild } from '@angular/core';
import { CommonService } from '../../../services/common/common.service';
import { RestService } from '../../../services/rest/rest.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { HelpIndex } from '../../../models/enums';
import { ConnectorPickerComponent } from '../../connector-picker/connector-picker.component';

@Component({
    standalone: false,
    selector: 'res-connector-picker-modal',
    templateUrl: './connector-picker-modal.component.html',
    styleUrls: ['./connector-picker-modal.component.scss']
})
export class ConnectorPickerModalComponent extends BaseModalComponent {
    @ViewChild(ConnectorPickerComponent, { static: true }) connectorPicker: ConnectorPickerComponent;

    // modal info
    modalTitle = 'Select Connector File';
    modalAutomationId = 'connector-picker-auto-id';
    verifyRequiredValidator = true;
    primaryButtonLabel = 'OK';
    secondaryButtonLabel = 'Cancel';
    modalHelpIndex = HelpIndex.select_connector_file_bulksearch_dlg;
    modalClass = '';

    constructor(
        private modalService: BsModalService,
        private commonService: CommonService,
        private modalRef: BsModalRef,
        private restService: RestService
    ) {
        super(modalService, modalRef);
    }

    ok() {
        this.closeModal(true, {
            selectedConnector: this.connectorPicker.selectedConnector,
            selectedFile: this.connectorPicker.selectedFile
        });
    }

    isPrimaryButtonEnabled() {
        return Boolean(this.connectorPicker && this.connectorPicker.selectedConnector && this.connectorPicker.selectedFile && this.connectorPicker.selectedFile.name.length > 0);
    }

}
